module.exports = __webpack_public_path__ + "img/abinoid-face-serum.aa6c77e5.jpg";